import {
  Configuration,
  LogLevel,
  PopupRequest,
  RedirectRequest,
} from "@azure/msal-browser";
import { SystemCredentials } from "us.common/constants";

const state: any = {
  accessToken: null,
  idToken: null,
  user: null,
  credentials: {
    subscriptionKey: "",
    instrumentationKey: "",
  },
};

export const loginRequest: RedirectRequest = {
  scopes: [
    `api://${window._ENV.REACT_APP_AZURE_WEB_API_CLIENT_ID}/BOXUser.Read`,
  ],
  prompt: "none", // Critical for SSO - try silent authentication first
  extraQueryParameters: {
    domain_hint: "organizations", // Optimize for organizational accounts
  },
};

// Fallback login request when silent fails
export const interactiveLoginRequest: PopupRequest = {
  scopes: [
    `api://${window._ENV.REACT_APP_AZURE_WEB_API_CLIENT_ID}/BOXUser.Read`,
  ],
  prompt: "select_account", // Allow account selection when interaction is needed
  extraQueryParameters: {
    domain_hint: "organizations",
  },
};

// Silent token request for SSO
export const silentRequest = {
  scopes: [
    `api://${window._ENV.REACT_APP_AZURE_WEB_API_CLIENT_ID}/BOXUser.Read`,
  ],
  forceRefresh: false, // SSO optimization - use cached tokens when possible
};

// Logout request for proper SSO cleanup
export const logoutRequest = {
  postLogoutRedirectUri: `${window.location.origin}` as string,
  mainWindowRedirectUri: `${window.location.origin}` as string,
};

export const msalConfig: Configuration = {
  auth: {
    clientId: window._ENV.REACT_APP_AZURE_CLIENT_ID as string, //,
    authority: window._ENV.REACT_APP_AUTHORITY as string,
    redirectUri: `${window.location.origin}` as string,
    postLogoutRedirectUri: `${window.location.origin}` as string,
    navigateToLoginRequestUrl: true, // SSO optimization
  },
  cache: {
    cacheLocation: "localStorage", // Required for SSO across tabs and applications
    storeAuthStateInCookie: true, // Enable for better SSO support
    secureCookies: false, // Set to true in production with HTTPS
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(`[MSAL] ${message}`);
            return;
          case LogLevel.Info:
            console.info(`[MSAL] ${message}`);
            return;
          case LogLevel.Verbose:
            console.debug(`[MSAL] ${message}`);
            return;
          case LogLevel.Warning:
            console.warn(`[MSAL] ${message}`);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Info,
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false, // Better for SSO reliability
  },
};

const authenticationAD = {
  run: <P extends { accessToken: string; idToken: string }>(
    tokenResponse: P,
    decodedToken: any,
    callback: any
  ) => {
    state.accessToken = tokenResponse.accessToken;
    state.idToken = tokenResponse.idToken;
    state.user = decodedToken;
    callback();
  },
  setCredentials: <P extends SystemCredentials>(
    credentials: P,
    callback: any
  ) => {
    state.credentials = credentials;
    callback();
  },
  getAccessToken: () => state.accessToken,
  getIdToken: () => state.idToken,
  getUser: () => state.user,
  getCredentials: () => state.credentials,
};

export default authenticationAD;
